import React from 'react';
import uploadanimation from './upload-animation.json';
import Lottie from 'react-lottie-player';
function finalUploadloading() {
  return (
    <>
      <div className="flex items-center justify-center h-[100vh] w-[100%] flex-col">
        <Lottie
          loop
          animationData={uploadanimation}
          play
          style={{ width: 173, height: 173 }}
        />
        <p className='text-gray-400'>Uploading</p>
        <p className='text-gray-400 w-[300px] text-center'>Your Participation is getting ready, Admin will review and approve it soon.</p>
      </div>
    </>
  );
}

export default finalUploadloading;
